import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCandidateList } from "../../../redux/actions/admin/CandidateActions"
import { CircularProgress } from '@material-ui/core';
import { Helmet } from "react-helmet";
import ReactDatatable from '@ashvin27/react-datatable';

let columns = [
    {
        key: "firstName",
        text: "Prénom",
        className: "firstName",
        align: "left",
        sortable: true,
    },
    {
        key: "lastName",
        text: "Nom",
        className: "lastName",
        align: "left",
        sortable: true,
    },
    {
        key: "email",
        text: "Email",
        className: "email",
        align: "left",
        sortable: true,
    },
    {
        key: "phoneNumber1",
        text: "Téléphone",
        className: "phoneNumber1",
        align: "left",
        sortable: true,
    }
]

let config = {
    page_size: 25,
    length_menu: [25, 50, 100],
    button: {
        excel: false,
        print: false,
        extra: false,
    }
}

let CandidateListing = (props) => {

    const {
        getCandidateList,
        storeCandidate
    } = props;

    const [isLoading, setIsLoading] = React.useState(true);
    const [candidatesList, setCandidatesList] = React.useState([]);

    useEffect(() => {
        if (candidatesList.length == 0 && storeCandidate.candidateList.length == 0) {
            getCandidateList().then(resp => {
                setCandidatesList(resp);
                setIsLoading(false);
            });
        }
        else if (candidatesList.length == 0 && storeCandidate.candidateList.length > 0) {
            setCandidatesList(storeCandidate.candidateList);
            setIsLoading(false);
        }
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <title> Administration | Candidats  | Malibaara</title>
            </Helmet>
            {isLoading ?
                (
                    <>
                        <div className="row bg-white pt-4 mt-lg-0">
                            <div className="col-lg-12">
                                <div className="loading-container bg-white">
                                    <CircularProgress />
                                </div>
                            </div>
                        </div>
                    </>
                )
                :
                (
                    <>
                        <div className="row bg-white pt-4 mt-lg-0">
                            <div className="col-lg-12 mt-4 mt-lg-0">
                                <div className="row mb-4">
                                    <div className="col-md-7 col-sm-5 d-flex align-items-center">
                                        <div className="section-title-02 mb-0 ">
                                            <h4 className="mb-0">Liste des candidats</h4>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-5 col-sm-7 mt-3 mt-sm-0" style={{ textAlign: "right" }}>
                                        <a className="btn btn-md ml-sm-auto btn-primary" data-toggle="modal" data-target="#createEmployerModal">Ajouter un employeur</a>
                                    </div> */}
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="user-dashboard-info-box table-responsive mt-1 bg-white">
                                            <div>
                                                <ReactDatatable
                                                    config={config}
                                                    records={candidatesList}
                                                    columns={columns}
                                                    extraButtons={[]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
}

CandidateListing.propTypes = {
    getCandidateList: PropTypes.func.isRequired,
    storeCandidate: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    getCandidateList: PropTypes.func.isRequired,
    storeCandidate: state.candidate
});

export default connect(mapStateToProps, { getCandidateList })(CandidateListing)